import * as yup from 'yup';

import { AmountHelper } from 'modules/common/values';

import { Field } from '../../types/Field';

/**
 * Схема формы оплаты.
 */
export const schema = yup.object().shape({
  /**
   * Сумма платежа не может быть пустой
   */
  [Field.AMOUNT]: yup
    .string()
    .nullable()
    .test('amount', 'Сумма не должна быть меньше 1 ₽', (value) => {
      return Number(value) >= 1;
    })
    .required('Введите сумму платежа')
    .when([Field.AMOUNT_FULL], (amountFull: number, schema) => {
      return schema.test({
        is: (value: number) => !!value,
        test: (amount: string) => {
          const userAmount = AmountHelper.create(Number(amount));
          const remainingAmount = amountFull - userAmount;

          return !(remainingAmount > 0 && remainingAmount < 100);
        },
        message: `Мы не сможем принять ваш следующий платёж, так как он составит меньше 1
        рубля. Пожалуйста, оплатите ${AmountHelper.formatDisplayFloat(
          Number(amountFull),
        )} ₽ для полного погашения займа`,
      });
    }),
});

/**
 * Значения схемы.
 */
export type Values = yup.InferType<typeof schema>;
